import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { SimpleDropdown } from '../../../../../../../../../components/simple-dropdown';
import { Providers } from '../../../../../../../../../enums/providers';
import Global from '../../../../../../../../../store/global-selectors';
import { PARAMETER } from '../../../../../../constants/parameter-name-for-update';

import { messages } from './messages';

type AddServiceLevelRoyalMailProps = {
  onChange: (value: Record<string, string>) => void;
  inputValueProps?: Record<string, string>;
};

type ServiceLevel = {
  code: string;
};

type ServiceLevelsData = {
  providerId: number;
  isPrimaryAccount: boolean;
  serviceLevels: ServiceLevel[];
};

export const DEFAULT_SERVICE_LEVELS: ServiceLevel[] = [{ code: '01' }, { code: '02' }];

export const AddServiceLevelRoyalMail: FC<AddServiceLevelRoyalMailProps> = ({ onChange, inputValueProps }) => {
  const intl = useIntl();
  const serviceLevels: ServiceLevel[] =
    useSelector(Global.selectServiceLevelsData)?.find(
      ({ providerId, isPrimaryAccount }: ServiceLevelsData) =>
        providerId === Providers.IntersoftRoyalMail.labelProviderIdInt && isPrimaryAccount,
    )?.serviceLevels ?? DEFAULT_SERVICE_LEVELS;

  const [serviceLevel, setServiceLevel] = useState<string>();

  useEffect(() => {
    if (!inputValueProps?.parameter) {
      return;
    }

    setServiceLevel(inputValueProps.parameter);
  }, [inputValueProps?.parameter]);

  const onSelectionMade = useCallback(
    (serviceLevelCode: string) => {
      setServiceLevel(serviceLevelCode);
      onChange({
        [PARAMETER]: serviceLevelCode,
      });
    },
    [onChange],
  );

  return (
    <FlexColumn gap={Gap.Space4}>
      <Text textType={TextType.Label} value={messages.label} />
      <SimpleDropdown
        defaultTitle={intl.formatMessage(messages.placeholder)}
        dropdownMenuShouldHaveWidthOfButton
        fullWidth
        items={serviceLevels.map(({ code }: { code: string }) => ({
          key: code,
          name: code,
        }))}
        onItemSelected={onSelectionMade}
        selectedItemKey={serviceLevel}
      />
    </FlexColumn>
  );
};
